import React, { Fragment } from 'react'

export const AccountPageOrdersPaymentFailedInactive = () => (
    <Fragment>
        <b style={{ color: '#d3d3d3' }}>Paiement échoué</b>
    </Fragment>
)
